var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.298 3.451a.573.573 0 0 0-.157.086c-.125.111-4.358 4.981-4.405 5.068a.608.608 0 0 0-.031.473.689.689 0 0 0 .393.364.648.648 0 0 0 .477-.083c.067-.048 4.019-4.557 4.334-4.945.146-.18.18-.275.166-.465a.531.531 0 0 0-.278-.446.62.62 0 0 0-.499-.052m2.963.02c-.113.049-.486.466-3.449 3.852a479.372 479.372 0 0 1-3.34 3.797c-.009 0-.612-.593-1.338-1.317-1.42-1.415-1.387-1.388-1.659-1.382-.392.009-.665.434-.514.8.057.137 3.155 3.244 3.306 3.314a.56.56 0 0 0 .467-.005c.12-.051.431-.398 3.645-4.071a801.654 801.654 0 0 0 3.585-4.111.557.557 0 0 0-.024-.721.558.558 0 0 0-.679-.156M1.358 8.438A.564.564 0 0 0 .92 9c0 .126.015.186.072.28.04.067.752.799 1.613 1.659 1.638 1.634 1.652 1.646 1.902 1.646.297 0 .586-.289.586-.585 0-.219.013-.205-1.651-1.875-.874-.878-1.631-1.617-1.682-1.643a.54.54 0 0 0-.402-.044",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleCheckIcon);
export default __webpack_public_path__ + "static/media/doubleCheckIcon.9d59c3d4c318682031d37878fb75398b.svg";
export { ForwardRef as ReactComponent };